__turbopack_context__.v({
  "blockTable": "TgPbpq_blockTable",
  "column": "TgPbpq_column",
  "contents": "TgPbpq_contents",
  "contentsWrapper": "TgPbpq_contentsWrapper",
  "fixed": "TgPbpq_fixed",
  "full": "TgPbpq_full",
  "hasTitle": "TgPbpq_hasTitle",
  "outerContents": "TgPbpq_outerContents",
  "scrollRightButton": "TgPbpq_scrollRightButton",
  "titles": "TgPbpq_titles",
});
